import React from 'react';
import TaskShareComponent from '../../ui/TaskShareComponent';
import img from '../../../assets/images/img.svg';
import arrow from '../../../assets/images/dashboard/header/doenArrow.svg';
import notification from '../../../assets/images/dashboard/header/Notificon.svg';
import search from '../../../assets/images/dashboard/body/Search.svg';

const OrganizationRequests = () => {
    const users = [
        { id: 1, name: 'Lucas Fournier', image: img, accepted: true },
        { id: 2, name: 'Isabelle Fournier', image: img, accepted: false },
        { id: 3, name: 'Mathieu Fournier', image: img, accepted: true },
        { id: 4, name: 'Elise Fournie', image: img, accepted: false },
        { id: 5, name: 'Victoria H', image: img, accepted: false },
    ];

    return (
        <div className="">
            <div className='hidden lg:flex py-4 lg:pr-10 bg_header border-b-2 border-[#362269]'>
                <div className='relative hidden lg:flex items-center pl-8'>
                    <input type="search" placeholder='Search' className='min-w-[625px] h-8 border-0 rounded-lg' />
                    <img src={search} alt="search" className='absolute right-[15px] top-[10px] ' />
                </div>

                <div className='flex ml-auto items-center'>
                    <span className='w-8 h-8  rounded-full'><img src={img} alt="img" /></span>

                    <div className='flex items-center'>
                        <p className='pl-3 font-bold'>Organisation</p>
                    </div>

                    <img src={notification} alt="notification" className='pl-4 text-black' />
                </div>

            </div>


            <div className="px-4 relative lg:px-[30px] py-16 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-2 gap-6 mx-auto md:w-[90%]" >
                <div className='circle_design'></div>

                {[...Array(6)].map((_, index) => (
                    <TaskShareComponent key={index} users={users} />
                ))}
            </div>
        </div>
    );
};

export default OrganizationRequests;
